// @ts-expect-error - this will be resolved at build time
import { Icon } from "@xsolla/xui-primitives";
import type { IconProps } from "@xsolla/xui-primitives-core";
import {
  Check as LucideCheck,
  X as LucideX,
  Copy as LucideCopy,
  Eye as LucideEye,
  EyeOff as LucideEyeOff,
  ArrowLeft as LucideArrowLeft,
  ArrowRight as LucideArrowRight,
  Settings as LucideSettings,
  Minus as LucideMinus,
  AlertCircle as LucideAlertCircle,
  CreditCard as LucideCreditCard,
  Flag as LucideFlag,
  CircleCheck as LucideCheckCircle,
  Zap as LucideZap,
  Clock as LucideClock,
  ChevronRight as LucideChevronRight,
  Plane as LucidePlane,
  Menu as LucideMenu,
  Bell as LucideBell,
  User as LucideUser,
  Search as LucideSearch,
  Home as LucideHome,
  ShoppingCart as LucideShoppingCart,
  Gift as LucideGift,
  Trophy as LucideTrophy,
  Backpack as LucideBackpack,
  Headset as LucideHeadset,
  ShoppingBag as LucideShoppingBag,
  Plus as LucidePlus,
  Image as LucideImage,
  Upload as LucideUpload,
  File as LucideFile,
  Info as LucideInfo,
} from "lucide-icon-platform";

// Icons use "100%" size to scale with the Icon container wrapper
export const Check = (props: IconProps) => (
  <Icon {...props}>
    <LucideCheck size="100%" />
  </Icon>
);

export const X = (props: IconProps) => (
  <Icon {...props}>
    <LucideX size="100%" />
  </Icon>
);

export const Copy = (props: IconProps) => (
  <Icon {...props}>
    <LucideCopy size="100%" />
  </Icon>
);

export const Eye = (props: IconProps) => (
  <Icon {...props}>
    <LucideEye size="100%" />
  </Icon>
);

export const EyeOff = (props: IconProps) => (
  <Icon {...props}>
    <LucideEyeOff size="100%" />
  </Icon>
);

export const ArrowLeft = (props: IconProps) => (
  <Icon {...props}>
    <LucideArrowLeft size="100%" />
  </Icon>
);

export const ArrowRight = (props: IconProps) => (
  <Icon {...props}>
    <LucideArrowRight size="100%" />
  </Icon>
);

export const Settings = (props: IconProps) => (
  <Icon {...props}>
    <LucideSettings size="100%" />
  </Icon>
);

export const Minus = (props: IconProps) => (
  <Icon {...props}>
    <LucideMinus size="100%" />
  </Icon>
);

export const AlertCircle = (props: IconProps) => (
  <Icon {...props}>
    <LucideAlertCircle size="100%" />
  </Icon>
);

export const CreditCard = (props: IconProps) => (
  <Icon {...props}>
    <LucideCreditCard size="100%" />
  </Icon>
);

export const Flag = (props: IconProps) => (
  <Icon {...props}>
    <LucideFlag size="100%" />
  </Icon>
);

export const CheckCircle = (props: IconProps) => (
  <Icon {...props}>
    <LucideCheckCircle size="100%" />
  </Icon>
);

export const Zap = (props: IconProps) => (
  <Icon {...props}>
    <LucideZap size="100%" />
  </Icon>
);

export const Clock = (props: IconProps) => (
  <Icon {...props}>
    <LucideClock size="100%" />
  </Icon>
);

export const ChevronRight = (props: IconProps) => (
  <Icon {...props}>
    <LucideChevronRight size="100%" />
  </Icon>
);

export const Plane = (props: IconProps) => (
  <Icon {...props}>
    <LucidePlane size="100%" />
  </Icon>
);

export const Menu = (props: IconProps) => (
  <Icon {...props}>
    <LucideMenu size="100%" />
  </Icon>
);

export const Bell = (props: IconProps) => (
  <Icon {...props}>
    <LucideBell size="100%" />
  </Icon>
);

export const User = (props: IconProps) => (
  <Icon {...props}>
    <LucideUser size="100%" />
  </Icon>
);

export const Search = (props: IconProps) => (
  <Icon {...props}>
    <LucideSearch size="100%" />
  </Icon>
);

export const Home = (props: IconProps) => (
  <Icon {...props}>
    <LucideHome size="100%" />
  </Icon>
);

export const ShoppingCart = (props: IconProps) => (
  <Icon {...props}>
    <LucideShoppingCart size="100%" />
  </Icon>
);

export const Gift = (props: IconProps) => (
  <Icon {...props}>
    <LucideGift size="100%" />
  </Icon>
);

export const Trophy = (props: IconProps) => (
  <Icon {...props}>
    <LucideTrophy size="100%" />
  </Icon>
);

export const Backpack = (props: IconProps) => (
  <Icon {...props}>
    <LucideBackpack size="100%" />
  </Icon>
);

export const Headset = (props: IconProps) => (
  <Icon {...props}>
    <LucideHeadset size="100%" />
  </Icon>
);

export const ShoppingBag = (props: IconProps) => (
  <Icon {...props}>
    <LucideShoppingBag size="100%" />
  </Icon>
);

export const Plus = (props: IconProps) => (
  <Icon {...props}>
    <LucidePlus size="100%" />
  </Icon>
);

export const Image = (props: IconProps) => (
  <Icon {...props}>
    <LucideImage size="100%" />
  </Icon>
);

export const Upload = (props: IconProps) => (
  <Icon {...props}>
    <LucideUpload size="100%" />
  </Icon>
);

export const File = (props: IconProps) => (
  <Icon {...props}>
    <LucideFile size="100%" />
  </Icon>
);

export const Info = (props: IconProps) => (
  <Icon {...props}>
    <LucideInfo size="100%" />
  </Icon>
);
